module.exports = __webpack_public_path__ + "fonts/LatoLatin-SemiboldItalic.fcfbb9e.eot";